module.exports = __webpack_public_path__ + "img/violet_095.9585eaa0.png";